import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFSuspend = {};

export const IBF_SUSPEND = {
  value: 0x0010,
  name: "IBF_SUSPEND",
  size: 0,
  parse: (): IBFSuspend => {
    return {};
  },
} satisfies IBFHistoryRecordDefinition<IBFSuspend>;
